import React, { useState } from "react";
import { Box, Typography, Switch, AppBar, Toolbar, IconButton, FormControl, InputLabel, Select, MenuItem, TextField } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import axios from "axios";

const NotificationPage = () => {
  const [notificationEnabled, setNotificationEnabled] = useState(false);
  const [selectedLimit, setSelectedLimit] = useState("");

  const expenseLimits = [
    { label: "Weekly", value: "5,000" },
    { label: "Monthly", value: "25,000" },
    { label: "Quarterly", value: "75,000" },
    { label: "Two Quarters", value: "1,50,000" },
    { label: "Yearly", value: "10,00,000" },
  ];

  const handleToggle = async () => {
    const newStatus = !notificationEnabled; // Determine new status
    setNotificationEnabled(newStatus); // Update state optimistically

    try {
      await axios.get("http://127.0.0.1:8000/settings/notification/1", {
        params: { notification_enabled: newStatus },
      });
      console.log("Notification status updated successfully!");
    } catch (error) {
      console.error("Error updating notification status:", error);
      setNotificationEnabled(!newStatus);
    }
  };
  const handleLimitChange = (event) => {
    setSelectedLimit(event.target.value);
  };

  return (
    <Box sx={{ backgroundColor: "#f5f5f5", height: "100vh", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <AppBar position="static" sx={{ backgroundColor: "#ffffff", boxShadow: "none", borderBottom: "1px solid #e0e0e0" }}>
        <Toolbar>
          <IconButton edge="start" color="inherit">
            <ArrowBack />
          </IconButton>
          <Typography variant="h6" sx={{ ml: 2, color: "#000" }}>
            Notification
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Content */}
      <Box sx={{ p: 3 }}>
        {/* Notification Toggle */}
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 3 }}>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            Notification
          </Typography>
          <Switch checked={notificationEnabled} onChange={handleToggle} />
        </Box>

        {/* Conditionally Rendered Fields Below the Toggle */}
        {notificationEnabled && (
          <Box sx={{ mb: 3 }}>
            {/* Always Option */}
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
                Always
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Always active notifications"
                sx={{ backgroundColor: "#ffffff", borderRadius: 1 }}
              />
            </Box>

            {/* Set Timer */}
            <Box>
              <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
                Set Timer
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Set a timer (e.g., 10:00 AM - 6:00 PM)"
                sx={{ backgroundColor: "#ffffff", borderRadius: 1 }}
              />
            </Box>
          </Box>
        )}

        {/* Spending Limits Dropdown */}
        <Box>
          <Typography variant="body1" sx={{ fontWeight: "bold", mb: 2 }}>
            Set limit on Total expense
          </Typography>
          <FormControl fullWidth sx={{ backgroundColor: "#ffffff", borderRadius: 2 }}>
            <InputLabel id="expense-limit-label">Select Limit</InputLabel>
            <Select
              labelId="expense-limit-label"
              value={selectedLimit}
              onChange={handleLimitChange}
              label="Select Limit"
            >
              {expenseLimits.map((limit, index) => (
                <MenuItem key={index} value={limit.value}>
                  {limit.label} - {limit.value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
    </Box>
  );
};

export default NotificationPage;
